module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAYCAYAAACr3+4VAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2ElEQVRYhe2XsQ2DMBBFL1EaJmEG2IEdPAQNFU7NEOxgD+EV7CHcQkl0Ee2dLSVRpOOedNXnvvxB1hdwMDjnUARqlmXh1t+cz5Ae35jznBz2DhdBg0pDg0rjMkEf3ntSTCnBMAyknnMGbh9p2xZ9DkoPIVhjzJPz4PaRbduK5/hpv9V0nHNurvD5uKv1jkpDg0pDg0oDe5TsKOzRcRxvlD5N09H3ffGVoA9F0zTWe28pHbu66zrWf9/38mf59//ouq4ztx9jLHZkzegdlYYGlYYGlcY1ggLACzkEcysXFwqAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/OldCampIcons/028.png
// module id = 1038
// module chunks = 0